module.exports = __webpack_public_path__ + "b3002b2c55e87d388fd76acbb51a8ace.pdf";